import { playerStoreKey } from './playerStoreConstants'

export const playerStore = initialLocalStorageValues => {
  return { [playerStoreKey]: initialLocalStorageValues }
}
